import React, { useEffect } from 'react';
import { useAuth } from '@clatter/platform';
import { useLocation, useSearchParams } from 'react-router-dom';

const LogoutPageView = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { logout } = useAuth();

  const redirectTo = location?.state?.redirectTo || searchParams.get('redirectTo');
  const rootUrl = process.env.NX_PUBLIC_APP_ROOT_DOMAIN || window.location.origin;

  useEffect(() => {
    logout({
      returnTo: redirectTo ? rootUrl + `?redirectTo=${redirectTo}` : rootUrl,
    });
  }, [logout, redirectTo]);

  return null;
};

export default LogoutPageView;
